import {
  AfterViewInit,
  Component,
  HostListener,
  OnInit,
  ViewChild
} from '@angular/core';
import {NovoCartaoComponent} from "../novo-cartao/novo-cartao.component";

import {ActivatedRoute, Router} from "@angular/router";
import {ContatosService} from "../services/contatos.service";
import {AutorizacaoService} from "../services/autorizacao.service";
import {ChartComponent} from "@progress/kendo-angular-charts";
import {VendasFidelidadeService} from "../services/vendas-fidelidade.service";
import {EnumTipoDeAcao} from "../../../server/lib/emun/EnumTipoDeAcao";
import {Observable, timer} from "rxjs";
import {ConstantsService} from "../fidelidade/ConstantsService";
import {ContratoService} from "../superadmin/services/contrato.service";
import { EmpresasService } from '../superadmin/services/empresas.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { BotoesHomeComponent } from '../componentes/botoes-home/botoes-home.component';
import {CampanhaService} from "../services/campanha.service";
import {RotaGuardClient} from "../guards/auth-loja.guard";
import {DialogCloseResult, DialogService} from "@progress/kendo-angular-dialog";
import {FidelidadeComponent} from "../fidelidade/fidelidade.component";
import {DeviceDetectorService} from "ngx-device-detector";
import {SocketService} from "../services/socket.service";
import {FaturaAbertaPagarComponent} from "./fatura-aberta-pagar/fatura-aberta-pagar.component";
import {AvisoAtualizacaoAtivoVM, AvisosAtualizacaoService} from "../services/avisos-atualizacao.service";

declare const _;

@Component({
  providers: [ ],
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],

})
export class HomeComponent implements OnInit, AfterViewInit {
  @ViewChild(NovoCartaoComponent) dialogNovoCartao;
  @ViewChild(ChartComponent, {static: true})   chart;
  @ViewChild(FaturaAbertaPagarComponent, {static: false})   faturaAberta;
  @ViewChild('botoesHome', {static: false}) botoesHome: BotoesHomeComponent;
  resumo = {total: 0, qtdeAtivos: 0 , qtdeInativos: 0 };
  series: Observable<any>;
  seriesLabels: [] = [];
  graficos = ['dia' , 'mes' , 'ano' ];
  tipoGrafico ;
  ultimasAcoes: any = [];
  tipoDeAcaoEnum = EnumTipoDeAcao;
  resumoVenda: any = {
    total: 0, pontos: 0,  mesFormatado: 'Sem Vendas'
  };
  exibirFinanceiro = false;
  usuario: any;
  empresa: any;
  msg: any;
  novoPedido: any = {};
  carregou = false;
  fatura: any;
  fechouAlerta: Boolean;
  exibirModal: Boolean;
  exibirPedidos = false;
  marcando = false;
  msgStatus;
  total = 0;
  indice = 0;
  campanhasPendentes = [];
  timerAberto: any;
  isMobile: boolean;
  iframe: boolean;
  dialogWidth;
  avisosAtualizacaoDisponiveis: AvisoAtualizacaoAtivoVM[] = [];
  avisosAtualizacao: AvisoAtualizacaoAtivoVM[] = [];
  indiceAvisoAtualizacao = 0;
  exibirModalAvisosAtualizacao = false;
  carregandoAvisosAtualizacao = false;
  empresaCarregadaParaAvisosAtualizacao = false;
  faturaCarregadaParaAvisosAtualizacao = false;
  tentativaAutomaticaAvisosAtualizacao = false;
  avisosAtualizacaoPendentesPorConflito = false;
  private chaveSessaoAvisosAtualizacaoOcultos = 'promokit.avisosAtualizacao.ocultos';
  private chaveSessaoAvisosAtualizacaoVisualizados = 'promokit.avisosAtualizacao.visualizados';
  constructor(private router: Router,   private route: ActivatedRoute,
              private  contratoService: ContratoService,
              private autorizacaoService: AutorizacaoService , private vendasService: VendasFidelidadeService,
              private contatoService: ContatosService, private activatedRoute: ActivatedRoute,
              private dialogService: DialogService, private deviceService: DeviceDetectorService,
              private constantsService: ConstantsService, private empresasService: EmpresasService,
              private sanitizer: DomSanitizer, private campanhaService: CampanhaService,
              private avisosAtualizacaoService: AvisosAtualizacaoService,
              private socketService: SocketService) {
    this.isMobile = this.deviceService.isMobile()
    this.series = vendasService;
    this.tipoGrafico = this.graficos[0];
    let usuarioLogado = this.autorizacaoService.getUser();

    this.iframe = this.inIframe();

    if (usuarioLogado.garcom) {
      this.router.navigate(['/admin/pedidos-mesas'], {}).then(() => {
      });
      return
    }

    this.exibirFinanceiro = RotaGuardClient.visualizaRelatorios(usuarioLogado);
    this.constantsService.moduloPedido$.subscribe(data => this.exibirPedidos = data);

    if (!this.exibirFinanceiro) return;

    this.contatoService.obtenhaResumo({}).then(resumo => {
      this.resumo = resumo;
    });

    this.exibaGraficoDia();

    this.activatedRoute.queryParams.subscribe((queryParams: any) => {
      this.msg = queryParams.msg;
      this.novoPedido = {codigo: queryParams.codigo};
    });
    this.constantsService.moduloFidelidade$.subscribe(data => this.carregou = data != null);
    this.campanhaService.obtenhaCampanhas('', '', true).then( (respCampanhas: any) => {
      this.campanhasPendentes = respCampanhas.campanhas;
    });
    this.updateDialogWidth(window.innerWidth);
  }

  inIframe () {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }


  @HostListener('window:message', ['$event'])
  onMessage(e) {
    if (e.data.tipo === 'MENSAGEM_ADICIONAR_TAG') {
      if( e.data.fim ) {
        this.marcando = false;
      }

      this.total = e.data.total;
      this.indice = e.data.indice;
      this.msgStatus = this.sanitizer.bypassSecurityTrustHtml(e.data.msg);
    }
    else if( e.data.tipo === 'PKT_IMPORTE_CONTATOS' ) {
      this.msgStatus = this.sanitizer.bypassSecurityTrustHtml('Importando contatos...');

      const contatos = e.data.contatos;

      this.empresasService.importeContatos(this.empresa, contatos).then( (resp: any) => {
        this.botoesHome.terminouEnviarContatos();

        this.msgStatus = this.sanitizer.bypassSecurityTrustHtml(`<strong>Contatos Importados</strong>
<p class="mb-0">Novos: <strong>${resp.importados} contatos</strong></p>
<p>Existentes: <strong>${resp.existentes} contatos</strong></p>`);
      this.total = 100;
      this.indice = 100;
      }).catch( erro => {
        this.msgStatus = erro;
        this.botoesHome.terminouEnviarContatos();
      });
    }
  }

  ngOnInit() {
    this.atualizeTela();
    this.usuario = this.autorizacaoService.getUser() || {};
    this.constantsService.empresa$.subscribe( (empresa: any) => {
      if (!empresa) return;

      this.empresa = empresa;
      if (this.deveAbrirFilaSuporte()) {
        this.router.navigate(['/admin/suporte/fila']).then(() => {});
        return;
      }

      this.empresaCarregadaParaAvisosAtualizacao = true;
      this.carregueAvisosAtualizacaoSePossivel();
      if(this.isMobile) this.monitoreLojaFechada();
    });
    this.contratoService.obtenhaFaturaAberta().then( fatura => {
      this.fatura  = fatura;
      this.faturaCarregadaParaAvisosAtualizacao = true;
      this.carregueAvisosAtualizacaoSePossivel();

      if( this.route.snapshot.queryParams['pagarcartao'] ){
            setTimeout(() => {
              this.faturaAberta.abraModalPagarCartao();
            }, 500)
      }
    }).catch(() => {
      this.faturaCarregadaParaAvisosAtualizacao = true;
      this.carregueAvisosAtualizacaoSePossivel();
    })
  }

  ngAfterViewInit() {  }

  private deveAbrirFilaSuporte(): boolean {
    return this.iframe &&
      Number(this.empresa && this.empresa.id) === 1 &&
      !!(this.usuario && (this.usuario.admin || this.usuario.superadmin));
  }

  atualizeTela() {
    this.contatoService.obtenhaUltimasAcoes().then( ultimasAcoes => {
      this.ultimasAcoes = ultimasAcoes;
    });
  }


  exibaGraficoDia() {
    this.tipoGrafico = 'dia';
    this.vendasService.queryDia(this.seriesLabels, this.resumoVenda) ;
  }

  exibaGraficoMes() {
    this.tipoGrafico = 'mes';
    this.vendasService.queryMes(this.seriesLabels, this.resumoVenda) ;
  }

  exibaGraficoAno() {
    this.tipoGrafico = 'ano';
    this.vendasService.queryAno(this.seriesLabels, this.resumoVenda) ;
  }

  imprimaPedido(pedido: any) {
    window.open('/imprimir/pedido/' + pedido.guid);
  }

  fecheAterta() {
    this.fechouAlerta = true;
  }

  fecheModal() {
    this.exibirModal = true;
  }


  recarregue() {
    this.socketService.atualizeAbas();
  }

  sequence_operate(arr: any, index, fn){
    setTimeout(async () => {
      const objeto = arr[index];

      if( !objeto ) {
        return;
      }

      fn(objeto);
      this.sequence_operate(arr, index + 1, fn);
    }, 300);
  }

  adicionarTags() {
    this.marcando = true;
    this.contatoService.obtenhaContatosStatus().then( (contatos) => {
      window.parent.postMessage({tipo: "NOVA_MENSAGEM", text: {
          tipo: 'ADICIONE_TAG',
          contatos: contatos
        }}, "*");
    }).catch( (erro) => {});
  }

  fecharAlertaStatus() {
    this.msgStatus = null;
  }

  notifique(msg: string) {
    this.msgStatus = this.sanitizer.bypassSecurityTrustHtml(msg);
  }


  cliqueAcessarCampanha(campanhaPendente: any) {
    this.router.navigate(['/admin/marketing'], {}).then(() => {
    });
  }

  fecharAgora() {
    const windowRef = FidelidadeComponent.abraComoPopup(this.dialogService, false);

    windowRef.result.subscribe((result: any) => {
      if( result instanceof DialogCloseResult) {

      } else if (result) {
        this.empresa.estaRecebendoPedidos = result.fechou;
      }
      this.monitoreLojaFechada();
    });
  }

  private monitoreLojaFechada() {
    if(!this.empresa.estaAberta || !this.empresa.estaRecebendoPedidos){
      if(this.timerAberto) this.timerAberto.unsubscribe();

      const segundosTimer = 60;

      this.timerAberto =  timer(1000 * segundosTimer , 1000 * segundosTimer  ).subscribe( () => {

        this.empresasService.logada().then( (_empresa: any) => {
          this.empresa.estaAberta = _empresa.estaAberta;
          this.empresa.estaRecebendoPedidos = _empresa.estaRecebendoPedidos;

          if(  this.empresa.estaAberta &&   this.empresa.estaRecebendoPedidos )
            this.timerAberto.unsubscribe();

        });

      })
    }
  }

  reabrir() {
    this.empresasService.abra().then( (resposta) => {
      this.empresa.estaRecebendoPedidos = true;
    });
  }


  // Detecta a mudança de tamanho da tela
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateDialogWidth(event.target.innerWidth);
  }

  // Ajusta a largura do modal com base na largura da tela
  updateDialogWidth(width: number) {
    this.dialogWidth = width <= 768 ? '95%' : '700px';
  }

  get avisoAtualizacaoAtual(): AvisoAtualizacaoAtivoVM | null {
    return this.avisosAtualizacao[this.indiceAvisoAtualizacao] || null;
  }

  get primeiroAvisoAtualizacaoDisponivel(): AvisoAtualizacaoAtivoVM | null {
    return this.avisosAtualizacaoDisponiveis[0] || null;
  }

  get totalAvisosAtualizacao(): number {
    return this.avisosAtualizacao?.length || 0;
  }

  get totalAvisosAtualizacaoDisponiveis(): number {
    return this.avisosAtualizacaoDisponiveis?.length || 0;
  }

  get temAvisosAtualizacaoParaReabrir(): boolean {
    return this.totalAvisosAtualizacaoDisponiveis > 0;
  }

  get tituloCardAvisosPlataforma(): string {
    if (this.avisosAtualizacaoPendentesPorConflito) {
      return 'Há avisos pendentes para revisão';
    }

    return this.totalAvisosAtualizacaoDisponiveis > 1
      ? `${this.totalAvisosAtualizacaoDisponiveis} avisos disponíveis`
      : '1 aviso disponível';
  }

  get descricaoCardAvisosPlataforma(): string {
    if (this.primeiroAvisoAtualizacaoDisponivel?.resumo) {
      return this.primeiroAvisoAtualizacaoDisponivel.resumo;
    }

    if (this.avisosAtualizacaoPendentesPorConflito) {
      return 'Os avisos não abriram automaticamente porque havia outro modal prioritário no início.';
    }

    return 'Abra os avisos para revisar comunicados, atualizações e orientações da plataforma.';
  }

  get tituloCardAvisosAtualizacao(): string {
    if (this.avisosAtualizacaoPendentesPorConflito) {
      return 'Há novidades pendentes para revisão';
    }

    return this.totalAvisosAtualizacaoDisponiveis > 1
      ? `${this.totalAvisosAtualizacaoDisponiveis} novidades disponíveis`
      : '1 novidade disponível';
  }

  get descricaoCardAvisosAtualizacao(): string {
    if (this.primeiroAvisoAtualizacaoDisponivel?.resumo) {
      return this.primeiroAvisoAtualizacaoDisponivel.resumo;
    }

    if (this.avisosAtualizacaoPendentesPorConflito) {
      return 'Os avisos não abriram automaticamente porque havia outro modal prioritário no início.';
    }

    return 'Abra os avisos para revisar o que mudou recentemente na plataforma.';
  }

  get temAvisoAtualizacaoAnterior(): boolean {
    return this.indiceAvisoAtualizacao > 0;
  }

  get temProximoAvisoAtualizacao(): boolean {
    return this.indiceAvisoAtualizacao < this.totalAvisosAtualizacao - 1;
  }

  proximoAvisoAtualizacao(): void {
    const avisoAtual = this.avisoAtualizacaoAtual;
    if (!avisoAtual) {
      this.fecheModalAvisosAtualizacaoSemPersistencia();
      return;
    }

    this.registreConfirmacaoAvisoAtualizacao(avisoAtual);

    if (this.temProximoAvisoAtualizacao) {
      this.indiceAvisoAtualizacao += 1;
      this.registreVisualizacaoDoAvisoAtualizacao(this.avisoAtualizacaoAtual);
      return;
    }

    this.fecheModalAvisosAtualizacaoSemPersistencia();
  }

  avisoAtualizacaoAnterior(): void {
    if (!this.temAvisoAtualizacaoAnterior) {
      return;
    }

    this.indiceAvisoAtualizacao -= 1;
  }

  fecheModalAvisosAtualizacao(): void {
    this.adieAvisoAtualizacaoAtual();
  }

  verDepoisAvisoAtualizacao(): void {
    this.adieAvisoAtualizacaoAtual();
  }

  abrirAvisosAtualizacaoManualmente(): void {
    if (!this.temAvisosAtualizacaoParaReabrir) {
      return;
    }

    this.avisosAtualizacaoPendentesPorConflito = false;
    this.abraModalAvisosAtualizacao(this.avisosAtualizacaoDisponiveis);
  }

  fecheModalAvisosAtualizacaoSemPersistencia(): void {
    this.exibirModalAvisosAtualizacao = false;
  }

  private carregueAvisosAtualizacaoSePossivel(): void {
    if (this.carregandoAvisosAtualizacao || this.tentativaAutomaticaAvisosAtualizacao) {
      return;
    }

    if (!this.empresaCarregadaParaAvisosAtualizacao || !this.faturaCarregadaParaAvisosAtualizacao) {
      return;
    }

    this.tentativaAutomaticaAvisosAtualizacao = true;
    this.carregandoAvisosAtualizacao = true;

    this.avisosAtualizacaoService.obtenhaAtivos().then((avisos: AvisoAtualizacaoAtivoVM[]) => {
      this.carregandoAvisosAtualizacao = false;
      this.avisosAtualizacaoDisponiveis = avisos || [];
      const idsOcultosNaSessao = this.obtenhaIdsSessao(this.chaveSessaoAvisosAtualizacaoOcultos);
      const avisosFiltrados = (avisos || []).filter((aviso: AvisoAtualizacaoAtivoVM) => !idsOcultosNaSessao.includes(Number(aviso.id)));

      if (!avisosFiltrados.length) {
        this.avisosAtualizacaoPendentesPorConflito = false;
        return;
      }

      if (this.existeConflitoComModalDeAvisos()) {
        this.avisosAtualizacaoPendentesPorConflito = true;
        return;
      }

      setTimeout(() => {
        if (this.existeConflitoComModalDeAvisos()) {
          this.avisosAtualizacaoPendentesPorConflito = true;
          return;
        }

        this.abraModalAvisosAtualizacao(avisosFiltrados);
      }, 1200);
    }).catch(() => {
      this.carregandoAvisosAtualizacao = false;
    });
  }

  private existeConflitoComModalDeAvisos(): boolean {
    return !!(this.fatura && (this.fatura.vencida || this.fatura.venceHoje));
  }

  private abraModalAvisosAtualizacao(avisos: AvisoAtualizacaoAtivoVM[]): void {
    if (!avisos || !avisos.length) {
      return;
    }

    this.avisosAtualizacaoPendentesPorConflito = false;
    this.avisosAtualizacao = avisos.slice();
    this.indiceAvisoAtualizacao = 0;
    this.exibirModalAvisosAtualizacao = true;
    this.registreVisualizacaoDoAvisoAtualizacao(this.avisoAtualizacaoAtual);
  }

  obtenhaRotuloTipoAvisoAtualizacao(tipo: string): string {
    if (tipo === 'melhoria') return 'Melhoria';
    if (tipo === 'correcao') return 'Correção';
    if (tipo === 'importante') return 'Importante';
    return 'Novidade';
  }

  obtenhaClasseTipoAvisoAtualizacao(tipo: string): string {
    if (tipo === 'melhoria') return 'tipo-melhoria';
    if (tipo === 'correcao') return 'tipo-correcao';
    if (tipo === 'importante') return 'tipo-importante';
    return 'tipo-novidade';
  }

  obtenhaClassePrioridadeAvisoAtualizacao(prioridade: string): string {
    if (prioridade === 'alta') return 'prioridade-alta';
    if (prioridade === 'baixa') return 'prioridade-baixa';
    return 'prioridade-normal';
  }

  obtenhaIconeTipoAvisoAtualizacao(tipo: string): string {
    if (tipo === 'melhoria') return 'fa-lightbulb';
    if (tipo === 'correcao') return 'fa-cogs';
    if (tipo === 'importante') return 'fa-exclamation-circle';
    return 'fa-bullhorn';
  }

  obtenhaTextoPrioridadeAvisoAtualizacao(prioridade: string): string {
    if (prioridade === 'alta') return 'Prioridade alta';
    if (prioridade === 'baixa') return 'Prioridade baixa';
    return 'Prioridade normal';
  }

  obtenhaRotuloTipoAvisoPlataforma(tipo: string): string {
    if (tipo === 'melhoria') return 'Melhoria';
    if (tipo === 'correcao') return 'Correção';
    if (tipo === 'comunicado_operacional') return 'Comunicado operacional';
    if (tipo === 'indisponibilidade_suporte') return 'Indisponibilidade de suporte';
    if (tipo === 'manutencao') return 'Manutenção';
    if (tipo === 'importante') return 'Importante';
    return 'Novidade';
  }

  obtenhaClasseTipoAvisoPlataforma(tipo: string): string {
    if (tipo === 'melhoria') return 'tipo-melhoria';
    if (tipo === 'correcao') return 'tipo-correcao';
    if (tipo === 'comunicado_operacional') return 'tipo-comunicado-operacional';
    if (tipo === 'indisponibilidade_suporte') return 'tipo-indisponibilidade-suporte';
    if (tipo === 'manutencao') return 'tipo-manutencao';
    if (tipo === 'importante') return 'tipo-importante';
    return 'tipo-novidade';
  }

  obtenhaIconeTipoAvisoPlataforma(tipo: string): string {
    if (tipo === 'melhoria') return 'fa-lightbulb';
    if (tipo === 'correcao') return 'fa-cogs';
    if (tipo === 'comunicado_operacional') return 'fa-bullhorn';
    if (tipo === 'indisponibilidade_suporte') return 'fa-headset';
    if (tipo === 'manutencao') return 'fa-tools';
    if (tipo === 'importante') return 'fa-exclamation-circle';
    return 'fa-bullhorn';
  }

  obtenhaBlocosConteudoAvisoAtualizacao(conteudo: string): Array<{ tipo: 'paragrafo' | 'lista', itens: string[] }> {
    const blocos: Array<{ tipo: 'paragrafo' | 'lista', itens: string[] }> = [];
    const linhas = String(conteudo || '').split(/\r?\n/);
    let linhasParagrafo: string[] = [];
    let itensLista: string[] = [];

    const finalizeParagrafo = () => {
      const texto = linhasParagrafo.join(' ').trim();
      if (texto) {
        blocos.push({tipo: 'paragrafo', itens: [texto]});
      }
      linhasParagrafo = [];
    };

    const finalizeLista = () => {
      if (itensLista.length) {
        blocos.push({tipo: 'lista', itens: itensLista.slice()});
      }
      itensLista = [];
    };

    for (const linhaBruta of linhas) {
      const linha = String(linhaBruta || '').trim();

      if (!linha) {
        finalizeParagrafo();
        finalizeLista();
        continue;
      }

      if (/^([*\-•])\s+/.test(linha)) {
        finalizeParagrafo();
        itensLista.push(linha.replace(/^([*\-•])\s+/, '').trim());
        continue;
      }

      finalizeLista();
      linhasParagrafo.push(linha);
    }

    finalizeParagrafo();
    finalizeLista();

    return blocos;
  }

  private adieAvisoAtualizacaoAtual(): void {
    const avisoAtual = this.avisoAtualizacaoAtual;
    this.fecheModalAvisosAtualizacaoSemPersistencia();

    if (!avisoAtual) {
      return;
    }

    this.registreAdiamentoAvisoAtualizacao(avisoAtual);
  }

  private registreVisualizacaoDoAvisoAtualizacao(aviso: AvisoAtualizacaoAtivoVM | null): void {
    if (!aviso || this.existeIdNaSessao(this.chaveSessaoAvisosAtualizacaoVisualizados, aviso.id)) {
      return;
    }

    this.adicioneIdNaSessao(this.chaveSessaoAvisosAtualizacaoVisualizados, aviso.id);
    this.avisosAtualizacaoService.marqueVisualizado(aviso.id).catch(() => {});
  }

  private registreConfirmacaoAvisoAtualizacao(aviso: AvisoAtualizacaoAtivoVM): void {
    this.adicioneIdNaSessao(this.chaveSessaoAvisosAtualizacaoOcultos, aviso.id);
    this.avisosAtualizacaoService.marqueConfirmado(aviso.id).catch(() => {});
  }

  private registreAdiamentoAvisoAtualizacao(aviso: AvisoAtualizacaoAtivoVM): void {
    this.adicioneIdNaSessao(this.chaveSessaoAvisosAtualizacaoOcultos, aviso.id);
    this.avisosAtualizacaoService.marqueAdiado(aviso.id).catch(() => {});
  }

  private obtenhaIdsSessao(chave: string): number[] {
    try {
      const valor = sessionStorage.getItem(chave);
      if (!valor) {
        return [];
      }

      const ids = JSON.parse(valor);
      if (!Array.isArray(ids)) {
        return [];
      }

      return ids
        .map((item: any) => Number(item))
        .filter((item: number) => !Number.isNaN(item) && item > 0);
    } catch (erro) {
      return [];
    }
  }

  private existeIdNaSessao(chave: string, id: number): boolean {
    return this.obtenhaIdsSessao(chave).includes(Number(id));
  }

  private adicioneIdNaSessao(chave: string, id: number): void {
    try {
      const ids = this.obtenhaIdsSessao(chave);
      const idNormalizado = Number(id);

      if (!idNormalizado || ids.includes(idNormalizado)) {
        return;
      }

      ids.push(idNormalizado);
      sessionStorage.setItem(chave, JSON.stringify(ids));
    } catch (erro) {}
  }

}
